import { Badge, Text } from "@radix-ui/themes";

export function getStatusColor(status: string) {
  switch (true) {
    case ["open"].includes(status):
      return "blue";
    case ["deleted"].includes(status):
      return "red";
    case ["pending", "hold"].includes(status):
      return "yellow";
    case ["solved", "closed"].includes(status):
      return "green";
    default:
      return "gray";
  }
}

export const formatString = (value: string) =>
  value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

export const getStatusIcon = (value: string) => {
  const color = getStatusColor(value);

  return (
    <div
      className={`h-2 w-2  rounded-[2px]`}
      style={{ backgroundColor: `var(--${color}-10)` }}
    />
  );
};

export function StatusFormatter({
  value,
  variant = "badge",
  size = "1",
}: {
  value: string;
  variant?: "badge" | "text";
  size?: "1" | "2";
}) {
  const color = getStatusColor(value);

  if (variant === "text") {
    return (
      <Text size={size} color={color} weight={"medium"} highContrast>
        {formatString(value)}
      </Text>
    );
  }

  return (
    <Badge color={color} size={"1"} variant="outline">
      <Text
        size={size}
        color={color}
        weight={"medium"}
        className="flex items-center gap-1"
      >
        <div className={`h-2 w-2 bg-current rounded-[2px]`} />

        {formatString(value)}
      </Text>
    </Badge>
  );
}
